/**
 * 【KYMW1400】コマ入替VO
 *
 * @export ReplaceKomaModel
 * @class ReplaceKomaModel
 */
export class ReplaceKomaModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * コマＩＤ(入替元)
   */
  public komaIDFr = Number(0);

  /**
   * コマＩＤ(入替先)
   */
  public komaIDTo = Number(0);

  /**
   * ページ番号(入替元)
   */
  public pageNumFr = Number(0);

  /**
   * ページ番号(入替先)
   */
  public pageNumTo = Number(0);

  /**
   * 掲載料掲載枠数(入替元)
   */
  public publishAmountFr = Number(0);

  /**
   * 掲載料掲載枠数(入替先)
   */
  public publishAmountTo = Number(0);
}
